const searchToggle = document.querySelector(".searchToggle");
const svgUseElement = searchToggle.querySelector(".icon use");
const desktopSearch = document.querySelector("#desktopSearch");

function openSearch() {
    searchToggle.setAttribute("aria-expanded", "true");

    const newLabel = searchToggle.getAttribute("data-close-label");
    searchToggle.setAttribute("aria-label", newLabel);

    svgUseElement.setAttribute("xlink:href", "#iconClose");

    document.body.classList.add("searchActive");

    // Get the search input field and set focus on it after a brief delay
    setTimeout(() => {
      const searchInput = document.querySelector("#desktopSearchBar");
      if (searchInput) {
        searchInput.focus();
      }
    }, 200); // Adjust the delay as needed
  }

  function closeSearch() {
    searchToggle.setAttribute("aria-expanded", "false");

    const newLabel = searchToggle.getAttribute("data-open-label");
    searchToggle.setAttribute("aria-label", newLabel);

    svgUseElement.setAttribute("xlink:href", "#iconSearch");

    document.body.classList.remove("searchActive");

  }

  function toggleSearch(event) {
    if (event) event.stopPropagation();

    const isExpanded = searchToggle.getAttribute("aria-expanded") === "true";

    if (isExpanded) {
      closeSearch();
    } else {
      openSearch();
    }
  }

function setupSearchEventListeners() {
    const searchButton = document.querySelector(".searchButton");

    if (searchToggle) {

      if (!searchToggle || !desktopSearch || !svgUseElement) {
        return;
      }

      searchToggle.addEventListener("click", toggleSearch);
      document.addEventListener("click", (event) => {
        const isClickInside =
          desktopSearch.contains(event.target) ||
          searchToggle.contains(event.target);

        if (
          !isClickInside &&
          searchToggle.getAttribute("aria-expanded") === "true"
        ) {
          closeSearch();
        }
      });

      // Close search and remove searchActive when tabbing past the search button
      searchButton.addEventListener("blur", () => {
        setTimeout(() => {
            const focusedElement = document.activeElement;
            const searchInput = document.querySelector("#desktopSearchBar");

            // If focus is not on the search input or search button, close search and remove searchActive
            if (focusedElement !== searchInput && focusedElement !== searchButton) {
                closeSearch();
                document.body.classList.remove("searchActive");
            }
        }, 10);
    });
  }

    const initAutocomplete = function() {
        // console.log("DEBUG: All rek.ai dependencies are ready. Initializing...");

        // Check the Desktop Search Bar by itself
        const desktopInput = document.querySelector('#desktopSearchBar');
        if (desktopInput) {
            // console.log("DEBUG: Found #desktopSearchBar. Attaching autocomplete.");
            try {
                rekai_autocomplete('#desktopSearchBar').on('rekai_autocomplete:selected', function (event, suggestion, dataset) {
                    window.location = suggestion.url;
                });
            } catch (e) {
                console.error("ERROR initializing autocomplete on #desktopSearchBar:", e);
            }
        } else {
            console.warn("DEBUG: Could not find #desktopSearchBar on the page.");
        }

        // Check the Mobile Search Bar by itself 
        const mobileInput = document.querySelector('#mobileSearchInput');
        if (mobileInput) {
            // console.log("DEBUG: Found #mobileSearchInput. Attaching autocomplete.");
            try {
                rekai_autocomplete('#mobileSearchInput').on('rekai_autocomplete:selected', function (event, suggestion, dataset) {
                    window.location = suggestion.url;
                });
            } catch (e) {
                console.error("ERROR initializing autocomplete on #mobileSearchInput:", e);
            }
        } else {
            console.warn("DEBUG: Could not find #mobileSearchInput on the page.");
        }

        // Check the Search Page Bar by itself
        const searchPageInput = document.querySelector('#search');
        if (searchPageInput) {
            // console.log("DEBUG: Found #search. Attaching autocomplete.");
            try {
                rekai_autocomplete('#search').on('rekai_autocomplete:selected', function (event, suggestion, dataset) {
                    window.location = suggestion.url;
                });
            } catch (e) {
                console.error("ERROR initializing autocomplete on #search:", e);
            }
        } else {
            console.warn("DEBUG: Could not find #search on the page.");
        }
    };

    // Check if the main object and its core 'predict' function exist.
    // If it does, rek.ai is ALREADY ready.
    if (window.__rekai && typeof window.__rekai.predict === 'function') {
        // console.log("DEBUG: rek.ai was already ready. Running initialization immediately.");
        // Run our logic right now.
        initAutocomplete();
    } else {
        // Otherwise, the library is not ready yet.
        // We register our function to run when the 'ready' event fires.
        // console.log("DEBUG: rek.ai is not ready yet. Registering for the 'ready' event.");
        __rekai.ready(initAutocomplete);
    }
}

setupSearchEventListeners();